import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAuthLogin = z.any()
export type TagsPostAuthLogin = z.infer<typeof tagsPostAuthLogin>

export const bodyPostAuthLogin = z.object({ "email": z.string().email().min(1), "password": z.string().min(1) })
export type BodyPostAuthLogin = z.infer<typeof bodyPostAuthLogin>

export const responsePostAuthLogin = z.object({ "payload": z.object({ "name": z.string(), "session_id": z.string(), "type": z.union([z.literal("client"), z.literal("admin")]), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "privileges": z.array(z.string()), "clientRole": z.union([z.literal("READ_ONLY"), z.literal("CONSUMPTION_EDITOR"), z.literal("INVOICE_EDITOR"), z.literal("POWER_USER")]).optional(), "primaryUser": z.boolean().optional(), "accessibleBuildingIdsCount": z.number().optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAuthLogin = z.infer<typeof responsePostAuthLogin>

interface IPostAuthLogin extends BaseMethodType {
  tags: TagsPostAuthLogin,
  body: BodyPostAuthLogin,
  response: ResponsePostAuthLogin
}
export const URL = '/auth/login'
export const validation = {
  post: {
    tags: tagsPostAuthLogin,
    body: bodyPostAuthLogin,
    response: responsePostAuthLogin
  }
}
export interface AuthLogin extends BaseRouteType {
  post: IPostAuthLogin
}